module.exports = __webpack_public_path__ + "img/rugbyunion-dark.7d50fb25.svg";